<template>
    <!-- Modal -->
    <div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="klantModal"
         role="dialog" tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">New customer</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <klant-create></klant-create>
            </div>
        </div>
    </div>
</template>
<script>
    import KlantCreate from "@/views/customer/Form.vue"

    export default {
        components: {
            KlantCreate
        }
    }
</script>
